import { MediaTagsDisplay } from '../MediaTagsDisplay';

export class MediaTagsListPartner extends MediaTagsDisplay {

  constructor(props) {
    super(props, { pageForOrgType: 'PARTNER' })
  }
}



// WEBPACK FOOTER //
// ./src/screens/admin/partners/MediaTagsListPartner.js